export const getGiftCardList = state => {
    return state.list
}

export const getGiftCardDataProps = state => {
    return state.props
}

export const getGiftCardAutocompleteList = state => {
    return state.autocomplete_list
}



// WEBPACK FOOTER //
// ./src/store/modules/giftCard/getters.js